import React, { useEffect, useContext, useState } from "react";
import { Footer, Header, CustomTextInput } from "../../components";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../context/AuthContext";
import "./styles.css";
import { Modal } from "react-responsive-modal";
import IdentityModal from "./IdentityModal";

export default function IdentityVerification() {
  const userContextData = useContext(AuthContext);
  let { user_data, changeCodeStatus, loginData } = userContextData;
  const { t } = useTranslation();

  const [verificationModal, setVerificationModal] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(0);

  useEffect(() => {
    user_data();
  }, []);

  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="IdentityHeading mt-5">
              {t("Identity_Verification")}
            </h1>
          </div>
        </div>
      </div>

      <div className="container-fluid tableCss mt-5">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <table class="table">
              <tbody>
                <tr>
                  <td scope="col"></td>
                  <td scope="col" className="UnverifiedHeading">
                    {t("Unverified")} <br /> {t("Level_0")}
                  </td>
                  <td scope="col" className="UnverifiedHeading">
                    {t("Email_Verified")} <br /> {t("Level_1")}
                  </td>
                  <td scope="col" className="UnverifiedHeading">
                    {t("Phone_Number_Verified")}
                    <br /> {t("Level_2")}
                  </td>
                  <td scope="col" className="UnverifiedHeading">
                    {t("Identity_Verified")} <br /> {t("Level_3")}
                  </td>
                </tr>

                <tr>
                  <th scope="row" className="UnverifiedHeading">
                    {t("Limit_On")} <br /> {t("Market_Value")} <br />
                    {t("Single_Item")} <br /> {t("HKD")}
                  </th>
                  <td>
                    <p className="UnverifiedCount">1,000</p>
                  </td>
                  <td>
                    <p className="UnverifiedCount">2,000</p>
                  </td>
                  <td>
                    <p className="UnverifiedCount">2,000</p>
                  </td>
                  <td>
                    <p className="UnverifiedCount">100,000</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row" className="UnverifiedHeading">
                    {t("Limit_On")} <br /> {t("Market_Value")} <br />{" "}
                    {t("All_Items")} <br /> {t("Rented")} <br />
                    {t("HKD")}
                  </th>
                  <td>
                    <p className="UnverifiedCount">3,000</p>
                  </td>
                  <td>
                    <p className="UnverifiedCount">6,000</p>
                  </td>
                  <td>
                    <p className="UnverifiedCount">30,000</p>
                  </td>
                  <td>
                    <p className="UnverifiedCount">300,000</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row"></th>
                  <td> </td>
                  <td className="UnVerifiedBtnStyle">
                    {" "}
                    <button
                      disabled={loginData.email_verified_at}
                      onClick={() => {
                        setVerificationModal(true);
                        setVerificationStatus(1);
                      }}
                      class={`btn-custom btn-light UnVerifiedBtn ${
                        loginData.email_verified_at
                          ? "UnVerifiedBtn"
                          : "StartUnVerifiedBtn"
                      }`}
                    >
                      {loginData.email_verified_at ? (
                        t("Verified")
                      ) : (
                        <span>
                          {t("Start")} <br /> {t("Verification")}
                        </span>
                      )}
                    </button>
                  </td>
                  <td className="UnVerifiedBtnStyle">
                    {" "}
                    <button
                      disabled={loginData.phone_verified_at}
                      onClick={() => {
                        setVerificationModal(true);
                        setVerificationStatus(2);
                      }}
                      class={`btn-custom btn-light UnVerifiedBtn ${
                        loginData.phone_verified_at
                          ? "UnVerifiedBtn"
                          : "StartUnVerifiedBtn"
                      }`}
                    >
                      {loginData.phone_verified_at ? (
                        t("Verified")
                      ) : (
                        <span>
                          {t("Start")} <br /> {t("Verification")}
                        </span>
                      )}
                    </button>
                  </td>
                  <td className="UnVerifiedBtnStyle">
                    {" "}
                    <button
                      disabled={loginData.id_verified_at}
                      onClick={() => {
                        setVerificationModal(true);
                        setVerificationStatus(3);
                      }}
                      class={`btn-custom btn-light UnVerifiedBtn ${
                        loginData.id_verified_at
                          ? "UnVerifiedBtn"
                          : "StartUnVerifiedBtn"
                      }`}
                    >
                      {loginData.id_verified_at ? (
                        t("Verified")
                      ) : (
                        <span>
                          {t("Start")} <br /> {t("Verification")}
                        </span>
                      )}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="col-lg-1"></div>
        </div>
      </div>
      <Modal
        open={verificationModal}
        onClose={() => {
          setVerificationModal(false);
          changeCodeStatus();
        }}
        center
      >
        <IdentityModal
          verificationStatus={verificationStatus}
          loginData={loginData}
          onClose={() => {
            setVerificationModal(false);
            changeCodeStatus();
          }}
        />
      </Modal>
      <Footer />
    </>
  );
}

{
  /* <div className="container-fluid">
        <div className="row unverifiedRow">
          <div className="col-lg-3 col-md-4">
            <br />
            <br />
            <br />
            <div className="col-md-12 LimitBoxt">
              <h1 className="UnverifiedHeading">
                Limit on Market Value of Single Item (HKD)
              </h1>
            </div>
            <br />
            <br />
            <br />
            <div className="col-md-12 LimitBoxt">
              <h1 className="UnverifiedHeading">
                Limit on Market Value of All Items Rented (HKD)
              </h1>
            </div>
          </div>
          <div className="col-lg-2 col-md-4">
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                Unverified <br /> (Level 0)
              </h1>
            </div>
            <div className="col-md-12">
              <h1 className="UnverifiedCount">1,000</h1>
            </div>
            <br />
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                <h1 className="UnverifiedCount">3,000</h1>
              </h1>
            </div>
            <div className="col-md-12">
              <button class="btn-custom btn-light UnVerifiedBtn">
                Verified
              </button>
            </div>
          </div>
          <div className="col-lg-2 col-md-4">
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                Email Verified <br /> (Level 1)
              </h1>
            </div>
            <div className="col-md-12">
              <h1 className="UnverifiedCount">2,000</h1>
            </div>
            <br />
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                <h1 className="UnverifiedCount">6,000</h1>
              </h1>
            </div>
            <div className="col-md-12">
              <button class="btn-custom btn-light UnVerifiedBtn">
                Verified
              </button>
            </div>
          </div>
          <div className="col-lg-2 col-md-4">
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                Phone Number Verified <br /> (Level 2)
              </h1>
            </div>
            <div className="col-md-12">
              <h1 className="UnverifiedCount">10,000</h1>
            </div>
            <br />
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                <h1 className="UnverifiedCount">3,000</h1>
              </h1>
            </div>
            <div className="col-md-12">
              <button class="btn-custom btn-light UnVerifiedBtn">
                Verified
              </button>
            </div>
          </div>
          <div className="col-lg-2 col-md-4">
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                Identity Verified <br /> (Level 3)
              </h1>
            </div>
            <div className="col-md-12">
              <h1 className="UnverifiedCount">100,000</h1>
            </div>
            <br />
            <div className="col-md-12">
              <h1 className="UnverifiedHeading">
                <h1 className="UnverifiedCount">300,000</h1>
              </h1>
            </div>
            <div className="col-md-12">
              <button class="btn-custom btn-light StartUnVerifiedBtn">
                Start <br /> Verification
              </button>
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div> */
}
